import { TableCell, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { StyledTableRow } from "components/BulkUpload";
import React, { useState } from "react";
import { useWatch, useFieldArray } from "react-hook-form";
import {
  getErrors,
} from "./utils";
import { InputLabel } from "components/BulkUpload";
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from "components/ConfirmDialog";

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const lgUp = "79px";
const lgDown = "70px";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  formControl: {
    minWidth: "200px",
  },
  hrsField: {
    minWidth: lgDown,
    maxWidth: lgDown,
  },
  [theme.breakpoints.up("xl")]: {
    hrsField: {
      minWidth: lgUp,
      maxWidth: lgUp,
    },
  },
  number: {
    fontSize: 14,
    textAlign: "center",
    "&[type=number]": {
      "-moz-appearance": "textfield",
      "-webkit-appearance": "textfield",
    },
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  textArea: {
    width: 'fit-content',
    textAlign: 'left'
  }
}));

const PunchRows = (props) => {
  const classes = useStyles();
  const {
    disabled,
    register,
    control,
    onUpdate,
    setValue,
    getValues,
    trigger,
    errors,
    dropdowns,
    fields = [],
    onDelete,
    watch
  } = props;

  const activityTotal = useWatch({ control, name: "activityTotal" });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen : false,
    title: "pgPunch.tlConfirmation",
    subTitle: "pgReview.msgDeletePunch",
    onConfirm: () => {},
  })
  const openDeleteConfirmModal = (index) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: true,
      onConfirm: () => {
        setConfirmDialog({...confirmDialog, isOpen: false});
        onDelete(index)
      }
    })
  }

  return (
    <>
      {fields?.length <= 0 ? (<>
        <StyledTableRow>
          <TableCell colSpan={10} align="center" style={{ padding: "40px" }}>
            <div style={{ fontSize: "16px", color: "#666" }}>
              No projects added yet.
            </div>
            <div style={{ marginTop: "8px", fontSize: "14px", color: "#999" }}>
              Please select a project above to start adding time entries.
            </div>
          </TableCell>
        </StyledTableRow>
      </>) : fields.map((record, index) => (
        <StyledTableRow className={classes.root} key={record.id}>
          <TableCell align="left">
            <InputLabel
              name={`records[${index}].details`}
              value={record?.['details']}
              fullWidth
              readOnly
              inputProps={{
                readOnly: true,
                className: classes.textArea
              }}
              multiline
              inputRef={register()}
            />
          </TableCell>
          {days.map((days, i) => (
            <TableCell key={`day${i}`} align="center">
              <TextField
                name={`records[${index}].day${i + 1}`}
                size="small"
                variant="outlined"
                defaultValue={record?.[`day${i + 1}`]}
                className={classes.hrsField}
                type="number"
                inputRef={register({
                  min: 0,
                  max: 24
                })}
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) &&
                  evt.preventDefault()
                }
                fullWidth
                inputProps={{
                  min: 0,
                  max: 24,
                  className: classes.number,
                  readOnly: false,
                }}
                error={getErrors(errors.records, index, `day${i + 1}`)}
                placeholder={"0"}
                onChange={(e) => {
                  let eventValue = e.target.value;
                  e.persist();
                  e.target.value = e.target.value
                    ? parseFloat(e.target.value)
                    : 0;
                  e.target.value =
                    eventValue.indexOf(".") >= 0
                      ? eventValue.substr(0, eventValue.indexOf(".")) +
                      eventValue.substr(eventValue.indexOf("."), 3)
                      : eventValue;
                  onUpdate(index, i + 1);
                }}
              />
            </TableCell>
          ))}
          <TableCell align="left">
            <InputLabel
              name={`activityTotal[${record?.['details']}].hours`}
              value={activityTotal?.[record?.['details']]?.['hours'] || "0"}
              fullWidth
              readOnly
              inputProps={{
                readOnly: true,
                style: { textAlign: 'center' },
                className: classes.number
              }}
             // inputRef={register()}
            />
          </TableCell>
          <TableCell align="left">
            <TextField
              size="small"
              name={`records[${index}].projectDetails`}
              defaultValue={record?.['projectDetails']}
              fullWidth
              readOnly
              inputRef={register()}
              inputProps={{maxLength: 251}}
              onChange={() => {
                onUpdate(index, -1);
              }}
              error={getErrors(errors.records, index, 'projectDetails')}
              helperText={
                getErrors(errors.records, index, "projectDetails") ?
                "Only 250 characters are allowed":
                `${watch(`records[${index}].projectDetails`)?.length || 0}/250`
              }
            />
          </TableCell>
          <TableCell align="left">
            <Tooltip title="Delete">
              <IconButton edge="start" style={{ padding: 0, color: '#f44336' }} color="error" onClick={() => openDeleteConfirmModal(index)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </StyledTableRow>
      ))}
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );

}

export default PunchRows;